module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-helper', [_c('div', {
    attrs: {
      "slot": "form-header"
    },
    slot: "form-header"
  }, [_c('h2', [_vm._v("Stammdaten")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-fields"
    },
    slot: "form-fields"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "name": "name",
      "label": "Name",
      "error": _vm.errors.has('name'),
      "id": "markename"
    },
    model: {
      value: (_vm.mk.name),
      callback: function($$v) {
        _vm.$set(_vm.mk, "name", $$v)
      },
      expression: "mk.name"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "small red--text"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('firmen-select')], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-commands"
    },
    slot: "form-commands"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.submitted
    }
  }, [_c('v-icon', {
    staticClass: "green--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/marken",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-297c8e36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marken/editMarken_1.vue
// module id = 313
// module chunks = 0